import React,{ Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getMenu } from '../actions'
import RubroBot from '../components/rubro_mod'


class HeaderNew extends Component{

	constructor(props) {
    super(props);
    this.state = {
      rubro:0,
      submenu:[],
      display:"block"
    }
    this.go = this.go.bind(this)
  }

  componentDidUpdate(prevProps, prevState){

  }

	componentWillMount() {
    this.props.getMenu()
  }

  go(dest){
    this.setState({
      display:"none"
    })
    this.props.history.push(dest)
  }

  render() {
    const  listaMenu = this.props.menu.opciones.map((rubro,i)=>{
      return (
        <RubroBot key={i} rubro={rubro}  go={this.go} categorias={ this.props.menu.opciones[i].categorias } />
      )
    })
//<Link to="/custom" className="enlace">CUSTOM</Link>  |
		return <div>
        <div className="w-100 text-right p-1" style={{ backgroundColor: "#3e454a", color: "#fff", fontSize: "12px" }}>
          {(this.props.usuario.tipo == "g" || this.props.usuario.tipo == "a") && <React.Fragment>
              <Link to="/admin" className="enlace">
                ADMIN
              </Link> |
            </React.Fragment>}
          {!this.props.usuario.user ? <Link to={"/login"} className="enlace">
              LOGIN{" "}
            </Link> : <Link to="/usuario/" className="enlace">
              {this.props.usuario.perfil.nombre + " " + this.props.usuario.perfil.apellido}
            </Link>}
          {this.props.carro.length > 0 && <Link to={"/carro"} className="enlace">
              {" "}
              CARRITO [{this.props.carro.length}]{" "}
            </Link>}| <Link to="/contacto" className="enlace">
            Contactanos
          </Link> | LLamanos : 0800-222-8358 o al 4568-4334
        </div>

        <nav>
        <ul className="prodsMenu flex-column flex-md-row">
            <li>
              <Link to={"/"} className="nav-link">
                <img src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/imgs%2Flogo.png?alt=media"} height="50" />
              </Link>
            </li>
            <div className="float-right" style={{ alignSelf: "flex-end" }}>
              {listaMenu}
            </div>
            <div className="float-right" style={{ alignSelf: "center", marginRight:"10px" }}>
            <Link to="/contacto" className="btn btn-primary"><i className="far fa-envelope"></i></Link>
            </div>
          </ul>
        </nav>
      </div>;
	}
}

const mapStateToProps = (state, ownProps) => {
  return {
      menu: state.menu,
      usuario: state.usuario,
      carro: state.productos.carro
    }
}

const mapDispatchToProps = dispatch => {
  return {
    getMenu: () => {
      dispatch(getMenu())
    }
  }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(HeaderNew))





// WEBPACK FOOTER //
// ./src/containers/headerNew.js